import { useCallback, useEffect } from "react";
import { showSparxsEditorEntryUnavailableToast } from "@/features/sparxsEditor/lib/blueprint/blueprintLoadToast";
import { useListLoad } from "@/hooks/sparxsCatalog/useListLoad";
import { useSearchIndexLoad } from "@/hooks/sparxsCatalog/useSearchIndexLoad";
import { selectCatalogFingerprint } from "@/store/sparxsCatalog/catalogSelectors";
import { selectEditorEntryBlocked } from "@/store/sparxsCatalog/editorEntryBlockedSlice";
import { useUserProfile } from "@/hooks/useUserProfile";
import { USER_FEATURE_TYPE } from "@/constants/userFeatureType";
import { useAppSelector } from "@/store/app/hooks";
import { selectSparxSaveEpoch } from "@/features/sparxsEditor/store/slices/interaction/eventHandlerSlice";

export const CatalogAndSearchIndexMount = () => {
  const { canAccessFeature } = useUserProfile();
  const canAccessSparxsEditor = canAccessFeature(
    USER_FEATURE_TYPE.SPARXS_EDITOR,
  );
  const editorEntryBlocked = useAppSelector(selectEditorEntryBlocked);
  const onSparxsListError = useCallback(() => {
    showSparxsEditorEntryUnavailableToast();
  }, []);

  const { buildList, cancelBuildList, catalogPersistReady } = useListLoad({
    onError: onSparxsListError,
  });

  const { buildIndex, cancelBuildIndex } = useSearchIndexLoad();

  const catalogFingerprint = useAppSelector(selectCatalogFingerprint);
  const sparxSaveEpoch = useAppSelector(selectSparxSaveEpoch);

  const catalogSubscriptionsReady =
    canAccessSparxsEditor === true &&
    catalogPersistReady === true &&
    editorEntryBlocked === null;

  useEffect(() => {
    if (!catalogSubscriptionsReady) {
      cancelBuildList();
      return;
    }
    buildList();
    return () => {
      cancelBuildList();
    };
  }, [catalogSubscriptionsReady, buildList, cancelBuildList]);

  useEffect(() => {
    if (!catalogSubscriptionsReady) {
      cancelBuildIndex();
      return;
    }
    buildIndex(catalogFingerprint);
    return () => {
      cancelBuildIndex();
    };
  }, [
    catalogSubscriptionsReady,
    catalogFingerprint,
    sparxSaveEpoch,
    buildIndex,
    cancelBuildIndex,
  ]);

  return null;
};
